import { useGetUser } from '@my-pages/hooks/useGetUser.ts';
import { backdoorMember } from '@my-pages/utils/backDoorUtils';
import { useGetApiV2MemberSuspense } from '@shared/integrations/taf-api/v2/features/member/member.ts';
import { IPerson } from '@shared/integrations/taf-api/v2/models';

export const useGetPerson = () => {
    const user = useGetUser();
    const { data: person } = user ? (user.roles?.includes('DevUser') ? { data: backdoorMember } : useGetApiV2MemberSuspense()) : { data: {} };
    return person as IPerson;
};
